module.exports = __webpack_public_path__ + "fonts/SFUIText-Bold.9817efee.woff2";